import toBool from 'utils/toBool'
import { z } from 'zod'

const RelapseClinicalApprovalFields = z.object({
	medicalObservation: z.string().optional(),
	needEscort: z.boolean().optional().transform(toBool),
	notes: z.string().optional(),
})

export const schema = (args) => {
	return RelapseClinicalApprovalFields.refine(
		(data) => !data.changeProvider || data.specialtyId,
		{
			message: 'Required',
			path: ['specialtyId'],
		}
	)
		.refine(
			(data) =>
				(data.changeProvider === undefined &&
					!!args?.establishmentId) ||
				!(
					data.changeProvider &&
					data.providerId &&
					data.providerId !== args?.establishmentId
				) ||
				!!data.differentProviderJustification?.length,
			{
				message: 'Required',
				path: ['differentProviderJustification'],
			}
		)
		.refine(
			(data) => !args?.requestEscort || data?.needEscort !== undefined,
			{
				message: 'Required',
				path: ['needEscort'],
			}
		)
}

export const strictSchema = (args) => {
	return RelapseClinicalApprovalFields.strict()
		.refine((data) => !data.changeProvider || data.specialtyId, {
			message: 'Required',
			path: ['specialtyId'],
		})
		.refine((data) => !data.changeProvider || data.providerId, {
			message: 'Required',
			path: ['providerId'],
		})
		.refine(
			(data) =>
				(data.changeProvider === undefined &&
					!!args?.establishmentId) ||
				!(
					data.changeProvider &&
					data.providerId &&
					data.providerId !== args?.establishmentId
				) ||
				!!data.differentProviderJustification?.length,
			{
				message: 'Required',
				path: ['differentProviderJustification'],
			}
		)
		.refine(
			(data) => !args?.requestEscort || data?.needEscort !== undefined,
			{
				message: 'Required',
				path: ['needEscort'],
			}
		)
}

const managerSchema = (args) => {
	return z.object({
		needsOptions: z
			.object({
				housing: z.boolean().optional().transform(toBool),
				transport: z.boolean().optional().transform(toBool),
			})
			.strict()
			.optional()
			.refine(
				(data) => data?.housing !== undefined || !args?.requestEscort,
				{
					message: 'Required',
					path: ['housing'],
				}
			)
			.refine(
				(data) => data?.transport !== undefined || !args?.requestEscort,
				{
					message: 'Required',
					path: ['transport'],
				}
			),
		notes: z.string().optional(),
		chargeAmount: z.number().optional(),
		administrativeObservation: z.string().optional(),
	})
}

export const ApproveRelapseClinicalSchema = (args) => schema(args)

export const RelapseClinicalApprovalSchema = (args) => strictSchema(args)

export const ExtendedRelapseClinicalApprovalSchema = (args) =>
	managerSchema(args)
